import React, { useState } from 'react';
import { Modal, Typography, Button, Popconfirm, AutoComplete, Spin } from 'antd';
import { queryClient } from '@/app/QueryClientProvider';
import { Container } from '@/ui';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { adminReferralApi, adminReferralApiKeys } from '@/api';
import { usePopups } from '@/hooks';
import { useDebounceSearch } from '@/hooks/useDebounceSearch';

export const SetAgentModal = ({ open, onClose, isFirst }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const { showErrorToast, showInfoToast, showSuccessToast } = usePopups();
  const {
    loading: loadingSearch,
    options,
    searchTerm,
    setSearchTerm,
    handleSearch,
    clearResults,
    loadMoreResults
  } = useDebounceSearch({
    type: 'agent'
  });
  const [code, setCode] = useState('');

  const makeRequest = async () => {
    if (code) {
      try {
        await adminReferralApi.setReferralCodeAgent({
          investorId: +id,
          referralCodeAgent: code.trim()
        });

        await queryClient.refetchQueries({ queryKey: [adminReferralApiKeys.getAgentsList] });
        showSuccessToast('Request is sent');
        setCode('');
        onClose();
      } catch (e) {
        console.error(e);
        showErrorToast(e, true);
      }
    } else {
      showInfoToast('Please enter code');
    }
  };

  const closeModal = () => {
    onClose();
    clearResults();
  };

  return (
    <Modal
      open={open}
      onCancel={closeModal}
      title={t('Set agent')}
      okText={t('Make request')}
      footer={[
        <Button key='back' onClick={closeModal}>
          {t('Cancel')}
        </Button>,
        <Popconfirm
          title={t('Set agent')}
          description={t('Are you sure you want to set the new agent?')}
          okText={t('Yes')}
          cancelText={t('No')}
          onConfirm={makeRequest}
          disabled={isFirst}
        >
          <Button type='primary' onClick={isFirst ? () => makeRequest() : null}>
            {t('Set')}
          </Button>
        </Popconfirm>
      ]}
    >
      <Container $marginBottom={4}>
        <Typography.Text>{t('Set agent request')}</Typography.Text>
      </Container>
      <Container $marginTop={10} $marginBottom={15}>
        <AutoComplete
          placeholder={t('Enter agent code')}
          value={searchTerm}
          options={options}
          onSearch={handleSearch}
          onSelect={(selected) => setSearchTerm(selected)}
          style={{ width: '100%' }}
          notFoundContent={loadingSearch ? <Spin size='small' /> : null}
          allowClear
          onPopupScroll={(e) => loadMoreResults(e, searchTerm)}
        />
      </Container>
    </Modal>
  );
};
